/**
 * @generated SignedSource<<fcf2c4f43bfcd96d3b710d179973776b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$data = {
  readonly viewSettings: {
    readonly isGroupingEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_spreadsheetViewResult" | "main_issueNavigator_IssueResults_spreadsheetView" | "topBar_issueNavigator_spreadsheetViewResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_spreadsheetView";
};
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_spreadsheetView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_spreadsheetView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_spreadsheetView",
  "selections": [
    {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isGroupingEnabled"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_spreadsheetViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_spreadsheetViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_spreadsheetView"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "cd0ca401d2b24fc6dd0457f569e0d01a";

export default node;
